<template>

    <div class="checklist-maker-step-3">

        <p>
            Select your checklist items
        </p>

        <b-btn variant="primary" size="lg"
               @click="openAddChecklistItemModal()">
            <open-icon name="plus"></open-icon>
            Add Checklist Item...
        </b-btn>

        <p>
        </p>

        <draggable class="dragArea"
                   v-model="docData.checklistItems">
            <b-card no-body class="drag mb-1"
                    v-for="item in docData.checklistItems" :key="item.key">
                <b-card-body class="pt-3 pb-2">
                    <b-row class="drag text-center">
                        <b-col cols="1">
                            <open-icon name="resize-height"></open-icon>
                        </b-col>
                        <b-col cols="9">
                            <b-form-textarea v-model="item.text"></b-form-textarea>
                        </b-col>
                        <b-col cols="2">
                            <b-btn variant="default" size="sm"
                                   @click="deleteChecklistItem(item)">
                                <open-icon name="delete"></open-icon>
                            </b-btn>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </draggable>

        <!-- add checklist item modal -->

        <b-modal id="add-checklist-item-modal"
                 title="Add a Checklist Item">

            <b-btn variant="primary" class="float-right"
                   @click="addChecklistItem('Custom...', config.checklistMaker.checklistTypes[docData.checklistType - 1].responses)">
                <open-icon name="plus"></open-icon>
                Add Custom Item
            </b-btn>

            <div style="clear:both; padding: 5px"></div>

            <div v-for="(group, g) in config.checklistMaker.checklistTypes[docData.checklistType - 1].checklistGroups"
                 :key="g">
                <b-card no-body>
                    <b-card-header v-b-toggle="`group_${g}`" class="checklist-group">
                        <open-icon name="chevron-bottom" v-if="group.visible"></open-icon>
                        <open-icon name="chevron-right" v-if="!group.visible"></open-icon>
                        <span>{{ group.title }}</span>
                        <b-btn variant="success" class="mr-2 float-right add-all-button"
                               @click="addAllItemsInGroup(group)">
                            Add All
                        </b-btn>
                    </b-card-header>
                    <b-collapse :id="`group_${g}`"
                                v-model="group.visible">
                        <b-card-body>
                            <b-btn variant="success" class="select-statement-button"
                                   v-for="(item, i) in group.items" :key="i"
                                   @click="addChecklistItem(item.text, config.checklistMaker.checklistTypes[docData.checklistType - 1].responses)">
                                {{ item.text }}
                            </b-btn>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>

        </b-modal>
    </div>

</template>

<script>

import Vue from 'vue'
import draggable from 'vuedraggable'
import ToolMixin from '@/providers/ToolMixin'

export default Vue.extend({
    name: "ChecklistMakerStep3",
    mixins: [ToolMixin],
    components: {
        draggable,
    },
    // data() {
    // },
    methods: {
        openAddChecklistItemModal() {
            this.$bvModal.show('add-checklist-item-modal')
        },
        addChecklistItem(text, responses) {
            // NB: must update checklistItems thus in order for the docData watcher to fire when the array
            // is initially empty! (see App::watch)
            Vue.set(this.docData, 'checklistItems', _.concat(
                this.docData.checklistItems ? this.docData.checklistItems : [],
                [{text: text, responses: responses}]
            ))
            this.$bvModal.hide('add-checklist-item-modal')
        },
        deleteChecklistItem(item) {
            this.docData.checklistItems = _.without(this.docData.checklistItems, item)
        },
        addAllItemsInGroup(group) {
            for (const item in group.items) {
                Vue.set(this.docData, 'checklistItems', _.concat(
                    this.docData.checklistItems ? this.docData.checklistItems : [],
                    [{text: group.items[item].text, responses: this.config.checklistMaker.checklistTypes[this.docData.checklistType - 1].responses}]
                ))
            }
            this.$bvModal.hide('add-checklist-item-modal')
        },
    },
    mounted() {
        for (const type in this.config.checklistMaker.checklistTypes) {
            for (const group in this.config.checklistMaker.checklistTypes[type].checklistGroups) {
                this.config.checklistMaker.checklistTypes[type].checklistGroups[group].visible = false
            }
        }
    }
})

</script>

<style lang="scss">

.checklist-maker-step-2 {

}

.select-statement-button {
    white-space: normal;
    text-align: left;
    margin-bottom: 10px;
}

</style>
